import React, { useEffect, useState, useReducer, useRef } from "react";
import { useStoreState, APP_STORE_ACTION, useStoreDispatch } from '../../common/storeContext'
// import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import { Container, Form, Modal } from "react-bootstrap";
import { useTranslation, Trans } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import PageTitle from '../pageTitle/template_01';
import { useForm } from "react-hook-form";
import { useMiddletier } from "../../common/middletier";
import AddressDialog from "../../components/AddressDialog"
import { TENANT_BUCKET } from '../../common/constants';
import { Navigate, useNavigate } from 'react-router-dom';
import Loading from '../../components/Loading';
import './template_01.css';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { useLocation } from 'react-router-dom';
import ImageWithPlaceholder from '../../components/ImageWithPlaceholder'


const REGISTER_ACTION = {
  SET_EXIST_STATUS: 'SET_EXIST_STATUS',
  SET_SELECTED_VERIFY_TYPE: 'SET_SELECTED_VERIFY_TYPE',
  SET_VERIFY_ID: 'SET_VERIFY_ID',
  SET_VERIFY_CODE: 'SET_VERIFY_CODE',
  SET_CODE_VALIDATION_RESULT: 'SET_CODE_VALIDATION_RESULT',
  SET_COUNTRY_DAILING_CODE: 'SET_COUNTRY_DAILING_CODE',
  SET_SELECTED_COUNTRY_DAILING_CODE: 'SET_SELECTED_COUNTRY_DAILING_CODE'

}

const initialRegisterData = {
  usernameExist: false,
  phoneNumberExist: false,
  emailExist: false,
  phoneNumberError: false,
  emailError: false,
  selectedVerifyType: '',
  verifyID_SMS: '',
  verifyCode_SMS: '',
  verifyID_EMAIL: '',
  verifyCode_EMAIL: '',
  codeValidationResult: true,
  countryDailingCode: [],
  selectedCountryDailingCode: ''
}

const registerReducer = (state, action) => {
  switch (action.type) {

    case REGISTER_ACTION.SET_EXIST_STATUS: {
      const { field, value } = action.payload;
      return { ...state, [field]: value ?? false };
    }

    case REGISTER_ACTION.SET_SELECTED_VERIFY_TYPE: {
      return { ...state, selectedVerifyType: action.payload };
    }

    case REGISTER_ACTION.SET_VERIFY_ID: {
      const { field, value } = action.payload;
      return { ...state, [field]: value };
    }

    case REGISTER_ACTION.SET_VERIFY_CODE: {
      const { field, value } = action.payload;
      return { ...state, [field]: value };
    }

    case REGISTER_ACTION.SET_CODE_VALIDATION_RESULT: {
      return { ...state, codeValidationResult: action.payload };
    }

    case REGISTER_ACTION.SET_COUNTRY_DAILING_CODE: {
      const countryDailingCode = action.payload
      return { ...state, countryDailingCode, selectedCountryDailingCode: countryDailingCode?.length > 0 ? countryDailingCode[0] : '60' };
    }

    case REGISTER_ACTION.SET_SELECTED_COUNTRY_DAILING_CODE: {
      return { ...state, selectedCountryDailingCode: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

// VALIDATION RULES
const getValidationRules = (type, t, getValues, appState) => {
  switch (type) {
    case 'username':
      return {
        required: t('error_username_empty'),
        minLength: { value: 6, message: t('error_username_length') },
        maxLength: { value: 12, message: t('error_username_length') },
      };
    case 'password':
      return {
        required: t('error_password_empty'),
        minLength: { value: 6, message: t('error_password_length') },
      };
    case 'confirm_password':
      return {
        required: t('error_confirm_password_empty'),
        minLength: { value: 6, message: t('error_confirm_password_length') },
        validate: (value) => {
          const { password } = getValues();
          return (
            password === value || t('error_confirm_password_matchPassword')
          );
        },
      };
    case 'affiliate':
      return {
        required: false,
        minLength: { value: 6, message: 'Affiliate min length 6' },
        maxLength: { value: 6, message: 'Affiliate max length 6' },
      };
    case 'agreement':
      return {
        required: true,
      };
    case 'fullname':
      return {
        required: t('error_fullname_empty'),
        pattern: { value: /^[A-Za-z\s]+$/i, message: t('error_fullname_format') },
      };
    case 'email':
      return {
        required: appState.registration.emailRequired && t('error_email_empty'),
        pattern: { value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, message: t('error_email_format') },
      };
    case 'code':
      return {
        required: t('error_code_empty'),
      };
    case 'phone_number':
      return {
        required: appState.registration.phoneRequired && t('error_phone_number_empty'),
        // pattern: { value: /^\(?(1[0-9]{1})\)?[-. ]?([0-9]{7,8})$/, message: t('error_phone_number_format') },
        pattern: { value: /^\d{8,}$/, message: t('error_phone_number_format') }
      };
    default:
      return {};
  }
};

// STEP 1
const One = (props) => {
  const appState = useStoreState()
  const [registerState, registerDispatch] = useReducer(registerReducer, initialRegisterData)
  const {
    register,
    setValue,
    getValues,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });
  const { t, i18n } = useTranslation();
  const { query } = useMiddletier()
  const [disabledNextButton, setDisabledNextButton] = useState(true)
  const [cartProduct, setCartProduct] = useState(true)
  const [isLoading, setLoading] = useState(false);
  const location = useLocation()
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })
  const appDispatch = useStoreDispatch()

  // WHEN FOCUS USERNAME INPUT
  const onFocusUsername = () => {
    registerDispatch({
      type: REGISTER_ACTION.SET_EXIST_STATUS,
      payload: { field: 'usernameExist', value: false },
    });
  }

  // CHECK IF USERNAME EXIST
  const checkUsername = () => {
    const { username } = getValues();
    if (username?.length > 0) {
      const method = 'checkUsername'

      query({
        method,
        params: [
          { code: 'username', graphqlType: 'String', required: true, value: username },
        ],
        attributes: []

      }).then(({ data }) => {
        registerDispatch({
          type: REGISTER_ACTION.SET_EXIST_STATUS,
          payload: { field: 'usernameExist', value: false },
        });
      }).catch((error) => {
        console.log('error: ', error)
        registerDispatch({
          type: REGISTER_ACTION.SET_EXIST_STATUS,
          payload: { field: 'usernameExist', value: true },
        });
      })
    }

  }







  useEffect(() => {

    setLoading(true)
    let getCartProduct = localStorage.getItem('cart_product');
    let filteredProduct = [];
    let filteredProductSave = [];

    if (getCartProduct !== null) {
      let formatCartProduct = JSON.parse(getCartProduct).reverse()

      query({
        method: 'getMallProducts',
        params: [
          { code: 'tenant', graphqlType: 'String', required: false, value: appState?.tenant },
          { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
        ],
        attributes: []
      }).then(({ data }) => {
        setLoading(false)
        formatCartProduct.forEach(item => {
          const foundProduct = data['getMallProducts'].find(product => product.id === item.id);
          if (foundProduct) {
            const productWithCartQuantity = { ...foundProduct, cart_quantity: item.cart_quantity }
            const productSaveId = { id: foundProduct.id, cart_quantity: item.cart_quantity }
            filteredProduct.push(productWithCartQuantity);
            filteredProductSave.push(productSaveId);
          }

          localStorage.setItem("cart_product", JSON.stringify(filteredProductSave));

          appDispatch({
            type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
            payload: {
              open: false,
              cart: JSON.stringify(filteredProductSave)
            }
          });

          setCartProduct(filteredProduct)

        });

      }).catch((error) => {
        setLoading(false)

      })


    }
    else {
      setLoading(false)

    }


  }, [location, appDispatch, i18n.resolvedLanguage, query, appState.tenant])

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, decimalPoint);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: decimalPoint,
      maximumFractionDigits: decimalPoint,
    });

    return formattedAmount;
  }

  const changeQuantity = (product, quantityChange) => {
    console.log('change Quantity', typeof quantityChange)
    let newQuantity
    
    // const updatedCartProduct = cartProduct.map((cartProductItem) => {

    //   if (typeof quantityChange === 'string') {

    //     newQuantity = parseInt(quantityChange);
    //     if (isNaN(newQuantity) || newQuantity < 1) {
    //       newQuantity = 1;
    //     } else {
    //       console.log('newQuantity', newQuantity)
    //     }
    //   } else {
    //     newQuantity = cartProductItem.cart_quantity + quantityChange;

    //   }

    //   if (cartProductItem.id === product.id) {
      
    //     if ((cartProductItem.quantity >= newQuantity || cartProductItem.quantity === -1)) {
    //       return { ...cartProductItem, cart_quantity: newQuantity };
    //     }else {
    //       appDispatch({
    //         type: APP_STORE_ACTION.SHOW_ALERT,
    //         payload: { description: `Quantity exceeds maximum limit of ${cartProductItem.quantity}. Please decrease the quantity.`, typeAlert: 'error' }
    //       });
    //       return { ...cartProductItem, cart_quantity: cartProductItem.cart_quantity };
    //     }
    //   }
    //   return cartProductItem;
    // });

    const updatedCartProduct = cartProduct.reduce((accumulatedCart, cartProductItem) => {
      let newQuantity;
    
      if (typeof quantityChange === 'string') {
        newQuantity = parseInt(quantityChange, 10); 
        if (isNaN(newQuantity) || newQuantity < 0) {
          
          return accumulatedCart;
        }
      } else {
        newQuantity = cartProductItem.cart_quantity + quantityChange;
      }
    
      if (cartProductItem.id === product.id) {
        if (newQuantity === 0) { 
          
          return accumulatedCart;
        } else if (cartProductItem.quantity >= newQuantity || cartProductItem.quantity === -1) {
       
          accumulatedCart.push({ ...cartProductItem, cart_quantity: newQuantity });
        } else {
          
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: `Quantity exceeds maximum limit of ${cartProductItem.quantity}. Please decrease the quantity.`, typeAlert: 'error' }
          });
          accumulatedCart.push({ ...cartProductItem, cart_quantity: cartProductItem.cart_quantity }); 
        }
      } else {
        
        accumulatedCart.push(cartProductItem);
      }
    
      return accumulatedCart; 
    }, []); 
    
    console.log('updatedCartProduct', updatedCartProduct)
    setCartProduct(updatedCartProduct);
    localStorage.setItem("cart_product", JSON.stringify(updatedCartProduct));

    appDispatch({
      type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
      payload: {
        open: false,
        cart: JSON.stringify(updatedCartProduct)
      }
    });
  }

  const removeProduct = (product) => {
    const getCurrentProduct = cartProduct.filter(item => item.id !== product.id);
    setCartProduct(getCurrentProduct)
    // const index = cartProduct.findIndex(item => item.id === product.id);
    // if (index !== -1) {
    //   cartProduct.splice(index, 1);
    // }
    // setCartProduct(cartProduct)
    localStorage.setItem("cart_product", JSON.stringify(getCurrentProduct));

    appDispatch({
      type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
      payload: {
        open: false,
        cart: JSON.stringify(getCurrentProduct)
      }
    });

  }

  const removeAllProduct = () => {
    localStorage.removeItem("cart_product");
    appDispatch({
      type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
      payload: {
        open: false,
        cart: '[]'
      }
    });
    setCartProduct([])
  }

  const checkOutCartProduct = () => {
    if (appState.loggedIn) {
      query({
        method: 'getMemberAddress',
        params: [],
        attributes: []

      }).then(({ data }) => {

        appDispatch({
          type: APP_STORE_ACTION.SET_ADDRESS,
          payload: data['getMemberAddress']
        });

        appDispatch({
          type: APP_STORE_ACTION.SET_CHECK_ADDRESS,
          payload: false
        });
// console.log('cartProduct',cartProduct)
        props.cartCallBack(cartProduct);
        props.nextStep();

      }).catch((error) => {
        if (error?.networkError?.statusCode === 401) {
          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
        } else {
          if (error.toString().includes("No Access Token") || error.toString().includes("tokens")) {
            appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
          } else {
            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: error.message.toString(), typeAlert: 'error' }
            });
          }

        }
      })



    }
    else {
      return appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: t('error_login_continue'), typeAlert: 'error' }
      });
    }
  }

  return (
    <>
      <div className="shoppingCart_Container">
        <div className="shoppingCart_productContainer">
          {
            cartProduct?.length ? (
              cartProduct.map(function (item, index) {
                return (
                  <div class="card_container">
                    <div class="card_wrap">
                      <figure class="card_image_wrap">
                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x1.png`} alt={item.title} />
                      </figure>
                      <div class="color_primary content_container">
                        <article class="card_content_wrap">
                          <div class="card_content_title">
                            {item.name}
                          </div>
                          <div class="card_content_desc_container">
                            <div className="productDetails_point">
                              {item.promotion_point && (<div className="promotion_point">{formatAmount(item.promotion_point ?? 0, appState?.loyaltyDecimalPoint)} <span className="point_name">{t('point')}</span></div>)}
                              <div className={`product_point ${item.promotion_point && 'discount'}`}>{formatAmount(item.point ?? 0, appState?.loyaltyDecimalPoint)}  <span className="point_name">{t('point')}</span></div>
                            </div>
                          </div>
                        </article>
                        <div class="card_action_wrap">
                          <div class="quantity_action_part">
                            <div class="number-input-button left" onClick={() => changeQuantity(item, -1)}>-</div>
                            <input type="number" className="shoppingCartQuantity" value={item.cart_quantity} onChange={(e) => changeQuantity(item, e.target.value)} />
                            <div class="number-input-button right" onClick={() => changeQuantity(item, 1)}>+</div>
                          </div>
                          <div class="button_action_part">
                            <button className="color_button font_button button_action" onClick={() => removeProduct(item)}> {t('remove')}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (<div className="d-flex align-items-center justify-content-center flex-column">
              <img src={`${TENANT_BUCKET}/icon/noRecord.png`} alt={''} className="no_record_img" />
              <span className="pt-1">{t('no_record')}</span>
            </div>)
          }
        </div>
        <div className={`shoppingCart_actionContainer ${cartProduct?.length ? 'd-flex' : 'd-none'}`}>
          <button type="button" className="color_button font_button button_action" onClick={removeAllProduct}> {t('delete')}</button>
          <div className="shoppingCartTotalCheckOut">
            <span>{t('total')} ({appState.totalCartCount ?? 0} {t('item')})</span>
            <button type="button" className="color_button font_button button_action" onClick={checkOutCartProduct}> {t('check_out')}</button>
          </div>
        </div>
      </div>
      {isLoading && (<Loading />)}
    </>
  );
};

// STEP 2
const Two = (props) => {
  const appState = useStoreState()
  const { t } = useTranslation();
  const { query, mutation } = useMiddletier()
  const [disabledPhoneBtn, setdisabledPhoneBtn] = useState(false);
  const [disabledEmailBtn, setdisabledEmailBtn] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(true);
  const [addressDialogShow, setAddressDialogShow] = useState(false);
  const [verifyDialogShow, setverifyDialogShow] = useState(false);

  const isProcessing = useRef(false);
  // const [phoneValue, setPhoneValue] = useState('');
  const [cartProduct, setCartProduct] = useState(true)
  const [cartPoint, setCartPoint] = useState(0)
  const [address, setAddress] = useState([])
  const [selectedAddress, setSelectedAddress] = useState("")

  const [isLoading, setLoading] = useState(false);
  const [isLoadingOTP, setLoadingOTP] = useState(false);

  // verification code modal
  const [timeExpires, setTimeExpires] = useState(+`${appState.registration.otpPinExpiresIn}`);
  const [send, setSend] = useState(false);
  const minutes = Math.floor(timeExpires / 60000);
  const seconds = Math.floor((timeExpires % 60000) / 1000);
  const [registerState, registerDispatch] = useReducer(registerReducer, initialRegisterData)
  const appDispatch = useStoreDispatch()

  const navigate = useNavigate();


  const {
    register: verifyCode,
    getValues: getCodeValue,
    formState: { errors: errorsCode },
    // handleSubmit: handleSubmitCode,
  } = useForm({
    mode: "onChange",
  });

  const handleBack = () => {
    props.previousStep();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const {
    register,
    getValues,
    formState: { errors, isValid, dirtyFields },
    handleSubmit,

  } = useForm({
    mode: "onChange",
  });



  const onChangeCountryDailingCode = (code) => {
    registerDispatch({ type: REGISTER_ACTION.SET_SELECTED_COUNTRY_DAILING_CODE, payload: code })
  }






  useEffect(() => {
    const getDefaultCountryDailingCode = appState.registration?.defaultCountryDailingCode ?? '60'
    if (appState.registration?.countryDailingCode?.includes(getDefaultCountryDailingCode)) {
      appState.registration?.countryDailingCode?.splice(appState.registration?.countryDailingCode.indexOf(getDefaultCountryDailingCode), 1);
    }

    appState.registration?.countryDailingCode?.unshift(getDefaultCountryDailingCode);

    registerDispatch({ type: REGISTER_ACTION.SET_COUNTRY_DAILING_CODE, payload: appState.registration?.countryDailingCode })


  }, [appState.registration?.countryDailingCode, appState.registration?.defaultCountryDailingCode]);

  useEffect(() => {

    const timer = setInterval(() => {
      setTimeExpires(timeExpires - 1000);
    }, 1000);

    if (timeExpires === 0) {
      clearInterval(timer);
      setSend(false)
      registerDispatch({
        type: REGISTER_ACTION.SET_VERIFY_ID,
        payload: { field: `${registerState.selectedVerifyType === 'SMS' ? 'verifyID_SMS' : 'verifyID_EMAIL'}`, value: '' },
      });
    }

    return () => {
      clearInterval(timer);
    };

  }, [timeExpires, send, registerState.selectedVerifyType]);

  useEffect(() => {

    // const otpNotSet =
    //   registerState.verifyID_SMS === '' &&
    //   registerState.verifyCode_SMS === '' &&
    //   registerState.verifyID_EMAIL === '' &&
    //   registerState.verifyCode_EMAIL === '';

    // const hasErrors =
    //   !isValid ||
    //   registerState.phoneNumberExist ||
    //   registerState.emailExist ||
    //   registerState.emailError ||
    //   registerState.phoneNumberError;

    // console.log('registerState.verifyID_SMS: ', registerState.verifyID_SMS)
    // console.log('registerState.verifyCode_SMS: ', registerState.verifyCode_SMS)

    // if (appState.registration.enabled_otp && otpNotSet) {
    //   setDisabledSubmit(true);
    // } else if (hasErrors) {
    //   setDisabledSubmit(true);
    // } else {
    //   setDisabledSubmit(false);
    // }

    if (appState.registration.enabled_otp) {
      if ((registerState.verifyID_SMS === '' || registerState.verifyCode_SMS === '') && (registerState.verifyID_EMAIL === '' || registerState.verifyCode_EMAIL === '')) {
        setDisabledSubmit(true)


      } else {
        if (!isValid || registerState.phoneNumberExist || registerState.emailExist || registerState.emailError || registerState.phoneNumberError) {
          setDisabledSubmit(true)



        } else {
          setDisabledSubmit(false)



        }
      }
    } else {
      if (!isValid || registerState.phoneNumberExist || registerState.emailExist || registerState.emailError || registerState.phoneNumberError) {
        setDisabledSubmit(true)



      } else {
        setDisabledSubmit(false)



      }
    }





  }, [registerState.verifyID_SMS, registerState.verifyID_EMAIL, isValid, registerState.phoneNumberExist, registerState.emailExist, registerState.verifyCode_SMS, registerState.verifyCode_EMAIL, appState.registration.enabled_otp, registerState.emailError, registerState.phoneNumberError]);

  // const formatAmount = (amount, decimalPoint) => {
  //   const factor = Math.pow(10, decimalPoint);
  //   const truncatedAmount = Math.floor(amount * factor) / factor;
  //   const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
  //     minimumFractionDigits: decimalPoint,
  //     maximumFractionDigits: decimalPoint,
  //   });

  //   return formattedAmount;
  // }

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, decimalPoint);
    const roundedAmount = Math.round(amount * factor) / factor; 
    const formattedAmount = roundedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: decimalPoint,
      maximumFractionDigits: decimalPoint,
    });
  
    return formattedAmount;
  }

  useEffect(() => {

    if (props?.cart?.length > 0) {

      // CALCULATE POINT
      // const totalCartPoint = props?.cart?.reduce((total, item) => {
      //   const pointValue = item.promotion_point != null ? parseFloat(item.promotion_point) : parseFloat(item.point);
      //   console.log(`pointValue ${item.name}`, pointValue)
      //   console.log(`pointValue  ${item.name} type`,typeof pointValue)
      //   // return parseFloat((total + (pointValue * item.cart_quantity)).toFixed(2));
      //   return total + (pointValue * item.cart_quantity);
      // }, 0);
      // setCartPoint(parseFloat(totalCartPoint.toFixed(2)));

      // const totalCartPoint = props?.cart?.reduce((total, item) => {
      //   const pointValue = item.promotion_point != null ? parseFloat(item.promotion_point) : parseFloat(item.point);
      //   return Number(total.toFixed(2)) + (pointValue * item.cart_quantity);
      // }, 0);

      const totalCartPoint = props?.cart?.reduce((total, item) => {
        const pointValue = item.promotion_point != null ? Math.trunc(item.promotion_point) : Math.trunc(item.point);
        return total + (pointValue * item.cart_quantity);
    }, 0);
    
       const totalPoint = 1.2 * 3;
      const roundedTotalPoint = Number(totalPoint.toFixed(2));
      console.log(totalCartPoint);
      setCartPoint(totalCartPoint);
      

      // IF MEMBER ADDRESS EMPTY WILL POPUP
      if ((appState?.address?.length === 0 && !appState.checkAddress)) {
        setAddressDialogShow(true)
      }

      if (appState.checkAddress) {
        props.previousStep()
      }
    }

  }, [props, appState?.address, appState.checkAddress])




  const onChangeAddress = (id) => {
    setSelectedAddress(id)
  }


  const onClickPlaceOrder = () => {
    const getProductInfo = props?.cart?.map((item) => {
      return { id: item.id, quantity: item.cart_quantity };
    })
    mutation([{
      method: 'createMallOrderByMember',
      params: [
        { code: 'deliveryAddress', graphqlType: 'String', required: true, value: appState.selectedAddress?.id },
        { code: 'productInfo', graphqlType: 'String', required: true, value: JSON.stringify(getProductInfo) },
      ],
      attributes: []

    }])
      .then(({ data }) => {
        console.log(data['createMallOrderByMember'])

        appDispatch({
          type: APP_STORE_ACTION.SHOW_ALERT,
          payload: { description: 'Add Successful', typeAlert: 'success' }
        });

        localStorage.removeItem("cart_product");
        appDispatch({
          type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
          payload: {
            open: false,
            cart: '[]'
          }
        });


        navigate('/')
        props.onHide()
      })
      .catch((error) => {
        // console.log('error: ', error)
        setLoading(false);
        if (error?.ne2rkError?.statusCode === 401) {
          appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
        } else {
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: error.message.toString(), typeAlert: 'error' }
          });
        }
      })
  }

  return (
    <>
      <div className="checkOut_Container">
        <div className="checkOut_DetailsContainer">
        <div className="checkOut_addressContainer">
          <div className="checkOut_title"> {t('shipping_address')}</div>
          <div className="checkOut_selectedAddressContainer">
            <div className="checkOut_selectedAddress"> {appState.selectedAddress?.recipient_phone_number && (<div>+{appState.selectedAddress?.recipient_phone_number}</div>)} <div>{appState.selectedAddress.address}</div></div>
            {appState.address?.length > 0 && (<div className="checkOut_changeSelectedAddress"><button type="button" className="color_button font_button button_action" onClick={() => setAddressDialogShow(true)}>{t('change')}</button></div>)}
          </div>

        </div>
        <div className="checkOut_productContainer">
          <div className="checkOut_title">{t('product_ordered')}</div>
          {
            props.cart?.length ? (
              props.cart?.map(function (item, index) {
                return (
                  <div class="card_container">
                    <div class="card_wrap">
                      <figure class="card_image_wrap">
                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x1.png`} alt={item.title} />
                      </figure>
                      <div class="color_primary content_container">
                        <article class="card_content_wrap">
                          <div class="card_content_title">
                            {item.name}
                          </div>
                          <div class="card_content_desc_container">
                            <div className="productDetails_point">
                              {item.promotion_point && (<div className="promotion_point">{formatAmount(item.promotion_point ?? 0, appState?.loyaltyDecimalPoint)} <span className="point_name">{t('point')}</span> </div>)}
                              <div className={`product_point ${item.promotion_point && 'discount'}`}>{formatAmount(item.point ?? 0, appState?.loyaltyDecimalPoint)} <span className="point_name">{t('point')}</span> </div>
                            </div>
                          </div>
                        </article>
                        <div class="card_action_wrap">
                          <div class="quantity_action_part">
                            <span>x {item.cart_quantity}</span>
                          </div>
                          {/* <div class="button_action_part">
                          <button className="color_button font_button button_action" onClick={() => removeProduct(item)}>Remove</button>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (<div className="d-flex align-items-center justify-content-center flex-column">
              <img src={`${TENANT_BUCKET}/icon/noRecord.png`} alt={''} className="no_record_img" />
              <span className="pt-1">{t('no_record')}</span>
            </div>)
          }
        </div>
        </div>
        <div className={`checkOut_orderSummaryWrap`}>
          <div className={`checkOut_orderSummaryContainer`}>
            <div className="checkOut_title">{t('order_summary')}</div>
            <div className="checkOut_itemPoint">
              <div>{t('item_point')}:</div>
              <div>{formatAmount(cartPoint ?? 0, appState?.loyaltyDecimalPoint)}  <span className="point_name">{t('point')}</span></div>
            </div>
            <div className="checkOut_myPoint">
              <div>{t('my_point')}:</div>
              <div>{formatAmount(appState.user?.reward_points ?? 0, appState?.loyaltyDecimalPoint)}  <span className="point_name">{t('point')}</span></div>
            </div>
          </div>
          <div className={`checkOut_orderSummaryContainer`}>
            <div className="checkOut_totalBalancePoint">
              <div>{t('total_balance_point')}:</div>
              <div>
                {formatAmount(appState.user?.reward_points - cartPoint ?? 0, appState?.loyaltyDecimalPoint)} <span className="point_name">{t('point')}</span> 
                {appState.user?.reward_points < cartPoint && (
                  <span>{t('insufficient_points_available')}</span>
                )}
              </div>

            </div>
            <div className="checkOut_placeOrder">
              <button type="button" className="color_button font_button button_action" onClick={handleBack}> {t('back')}</button>
              <button type="button" className="color_button font_button button_action" onClick={onClickPlaceOrder}> {t('place_order')}</button>
            </div>
          </div>
        </div>
      </div>
      <AddressDialog show={addressDialogShow} onHide={() => setAddressDialogShow(false)} defaultContent={appState.address?.length > 0 ? 'change' : 'first_add'} />
      {isLoading && (<Loading />)}
    </>
  );
};

// STEP 3
const Three = (props) => {
  const { t } = useTranslation();

  const handleLastStep = () => {
    props.completeCallback();
  };
  const { i18n } = useTranslation();


  return (
    <>
      <div className="register_form_step3">
        <img src={`${TENANT_BUCKET}/icon/register_successful_${i18n.resolvedLanguage}.png`} alt="register successful" />
        <h4 className="register_successful_content text-center">{t('register_successful')}</h4>
        <button type='button' className="font_button color_button register_btnDepositNow" onClick={handleLastStep}>{t('deposit_now')}</button>

        {props.birthdayReminder && (<><hr className="register_form_line" /><div><span style={{ color: 'red', paddingRight: '.25rem' }}>*{t('reminder')}</span> : <span style={{ paddingLeft: '.25rem' }}> {t('register_dob_reminder')}</span></div></>)}

        {/* DESKTOP REMINDER */}

        {/* <div className="register_form_reminder">
          <div className="register_form_reminder_title">
            *{t('reminder')}
          </div>:
          <div className="register_form_reminder_content">
            {t('register_reminder')}
          </div>
        </div> */}
      </div>
    </>
  );
};

const ShoppingCart = (props) => {
  // const [stepWizard, setStepWizard] = useState(null);
  const { t } = useTranslation();

  const appState = useStoreState()
  const { mutation } = useMiddletier()
  const appDispatch = useStoreDispatch()
  const [toLink, setToLink] = useState('/')
  const [cart, setCart] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [visitorId, SetVisitorId] = useState()


  const { desktopTitleToggle, mobileTitleToggle, birthdayReminder } = props;

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const assignStepWizard = (instance) => {
    // setStepWizard(instance);
  };

  const assignCart = (val) => {
    // console.log("parent receive user callback");
    // console.log(val);
    // setCart((cart) => ({
    //   ...cart,
    //   ...val
    // }));
    setCart(() => {
      return [...val]; 
  });
  };

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  return (
    <>

      <section id="shoppingCart_01">
        <div className={`shoppingCart_body ${!isDesktopOrLaptop && "shoppingCart_body_m"}`}>
          <PageTitle desktopToggle={false} mobileToggle={mobileTitleToggle} title={'shopping_cart'} id={'shoppingCart_title_m'} />

          <Container  className={isDesktopOrLaptop && "shoppingCart_body_container"}>
            <div className={`${isDesktopOrLaptop && "shoppingCart_container"} ${activeStep===1 ? "active_1":''}`}>
            {isDesktopOrLaptop && <div className="font_h2 color_primary shoppingCart_container_title">{t('shopping_cart')}</div>}
            {/* <PageTitle desktopToggle={true} mobileToggle={false} title={'shopping_cart'} id={'shoppingCart_title_d'} /> */}
            <div className="shoppingCart_container_wrap">
             <div className="shoppingCart_stepper_wrap">
                <div className="shoppingCart_stepper">
                  <div className={`active shoppingCart_stepContainer`}>
                    <button>
                      <span>1</span>
                    </button>
                  </div>
                  <div className={`${(activeStep === 1 || activeStep === 2) && 'active'} shoppingCart_stepContainer`}>
                    <button>
                      <span>2</span>
                    </button>
                  </div>
                  {/* <div className={`${activeStep === 2 && 'active'} shoppingCart_stepContainer`}>
                      <button>
                        <span>3</span>
                      </button>
                    </div> */}
                </div>
              </div>

              {/* NOTE: IMPORTANT !! StepWizard must contains at least 2 children components, else got error */}
              <div className="shoppingCart_form">

                <StepWizard instance={assignStepWizard} onStepChange={handleStepChange}>
                  <One cartCallBack={assignCart} />
                  <Two cart={cart}/>
                  {/* <Three cart={cart}  birthdayReminder={birthdayReminder} /> */}
                </StepWizard>
              </div>
            </div>
            </div>
          </Container>
        </div>
      </section>
    </>
  );
};

export default ShoppingCart;

